(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kbh-faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.kbh-faqp');
    if (!root) return;

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-faqp-chip]'));
    if (!chips.length) return;

    var map = {};
    chips.forEach(function (chip) { map[chip.getAttribute('data-faqp-chip')] = chip; });

    // smooth jump, letting the fixed header offset come from scroll-margin-top
    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        var target = document.getElementById(chip.getAttribute('data-faqp-chip'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // highlight the category currently in view
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faqp-group]'));
    if (!('IntersectionObserver' in window) || !groups.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        chips.forEach(function (c) { c.removeAttribute('aria-current'); });
        var active = map[entry.target.id];
        if (active) { active.setAttribute('aria-current', 'true'); }
      });
    }, { rootMargin: '-20% 0px -65% 0px' });

    groups.forEach(function (g) { observer.observe(g); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
